import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../../assets/css/timeTable.css';
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import Loader from '../../Shared/Loader/Loader';
import CommonConfig from '../../../utils/constant';
import moment from 'moment';

const EditTeacherTimeTable = (props) => {
    const { catchResponse } = useCatchResponse();
    const [classList, setClassList] = useState([]);
    const [subjectList, setSubjectList] = useState([]);
    const [classConfigMap, setClassConfigMap] = useState({});
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [periodsList, setPeriodsList] = useState([]);
    const [editTableData, setEditTableData] = useState([]);
    const currentYear = new Date().getFullYear();
    const [startDateValue, setStartDateValue] = useState(null);
    const [endDateValue, setEndDateValue] = useState(null);
    const [selectedYear, setSelectedYear] = useState(props?.location?.state?.financialYearId);
    const [academicStartDate, setAcademicStartDate] = useState(null);
    const [academicEndDate, setAcademicEndDate] = useState(null);
    const [isAcademicYearApply, setIsAcademicYearApply] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setClassList(props?.location?.state?.classList);
        const loginData = CommonConfig.loginData();
        GetSubjectList(loginData?._id);
        GetConfigurationData(loginData?._id);
        GetClassConfigMap(loginData);
        GetTimeTableData(props?.location?.state?.TeacherId, props?.location?.state?.startDate, props?.location?.state?.endDate, loginData?._id);
    }, []);

    useEffect(() => {
        if (isAcademicYearApply) {
            const academicCalendar = props?.location?.state?.academicYearList || [];

            if (!academicCalendar.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const validRanges = academicCalendar.filter(
                item => item?.StartDate && item.EndDate && item?._id === selectedYear
            );

            if (!validRanges.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const sortedCalendar = [...validRanges].sort(
                (a, b) =>
                    new Date(a?.StartDate) - new Date(b?.StartDate)
            );

            const start = new Date(sortedCalendar[0]?.StartDate);
            const end = new Date(sortedCalendar[0]?.EndDate);

            setAcademicStartDate(start);
            setAcademicEndDate(end);
        }
    }, [selectedYear, props?.location?.state?.academicYearList, isAcademicYearApply]);

    const GetClassConfigMap = async (loginData) => {
        try {
            const scopeId = CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : (loginData?.CreatedBy || loginData?._id);
            let data = { UserId: scopeId, FinancialYearId: selectedYear };
            await api.post(APIConstant.path.getClassConfigurationList, data).then(response => {
                if (response?.success) {
                    const map = {};
                    (response?.data || []).forEach(c => { if (c?.ClassId) map[String(c.ClassId)] = c?.AttendanceType; });
                    setClassConfigMap(map);
                }
            }).catch(err => {
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setIsAcademicYearApply(res?.data?.IsAcademicYearApply);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTimeTableData = async (teacherId, startDate, endDate, userId) => {
        try {
            let data = {
                TeacherId: teacherId,
                FinancialYearId: selectedYear,
                StartDate: !CommonConfig.isEmpty(startDate) && startDate !== '-' ? moment(startDate).format("YYYY-MM-DD") : '',
                EndDate: !CommonConfig.isEmpty(endDate) && endDate !== '-' ? moment(endDate).format("YYYY-MM-DD") : '',
                UserId: userId,
            }
            Loader.show();
            const response = await api.post(APIConstant.path.GetTimeTableByTeacher, data);
            if (response.success && response.data.length > 0) {
                setStartDateValue(response?.data[0]?.StartDate ? new Date(response?.data[0]?.StartDate) : null);
                setEndDateValue(response?.data[0]?.EndDate ? new Date(response?.data[0]?.EndDate) : null);

                const toDate = (time) => {
                    const match = time?.match(/(\d+):(\d+)\s(AM|PM)/);
                    if (!match) return null;
                    const [, hours, minutes, ampm] = match;
                    const hh = ampm === 'PM' && hours !== '12'
                        ? parseInt(hours, 10) + 12
                        : (ampm === 'AM' && hours === '12' ? 0 : parseInt(hours, 10));
                    const date = new Date();
                    date.setHours(hh, parseInt(minutes, 10), 0, 0);
                    return date;
                };
                const startMs = (timeRange) => {
                    const d = toDate((timeRange || '').split(' - ')[0]);
                    return d ? d.getTime() : Number.MAX_SAFE_INTEGER;
                };
                const isTeaching = (p) => p?.SubjectId && p.SubjectId !== 'Free' && p.SubjectId !== 'Break';

                // Columns = union of every distinct teaching time-slot across all days, so a
                // teacher's periods on any day (including combined-class times) each get their
                // own column placed at their real time — not squeezed into one day's layout.
                const slotSet = new Set();
                (response?.data || []).forEach(day => (day?.Periods || []).forEach(p => {
                    if (isTeaching(p) && p?.Time) slotSet.add(p.Time);
                }));
                let slotTimes = [...slotSet].sort((a, b) => startMs(a) - startMs(b));

                // Nothing assigned anywhere -> keep one editable column so the grid still renders.
                if (!slotTimes.length) {
                    const fallback = response?.data?.find(d => (d?.Periods || []).length)?.Periods?.[0]?.Time;
                    if (fallback) slotTimes = [fallback];
                }

                const periodData = slotTimes.map((time) => {
                    const [from, to] = (time || '').split(' - ').map(toDate);
                    return { Time: time, isEdit: false, isBreak: false, FromTime: from, ToTime: to };
                });
                setPeriodsList(periodData);

                const timeTableEditData = (response?.data || []).map(row => {
                    const formattedRow = { Day: row?.Day, id: row?.id };
                    const byTime = new Map();
                    (row?.Periods || []).forEach(p => { if (p?.Time) byTime.set(p.Time, p); });
                    slotTimes.forEach((time, index) => {
                        const period = byTime.get(time);
                        const teaching = period && isTeaching(period);
                        formattedRow[`Period${index + 1}`] = teaching ? period.SubjectId : 'Free';
                        formattedRow[`Class${index + 1}`] = teaching
                            ? (Array.isArray(period?.ClassIds) && period?.ClassIds?.length
                                ? period.ClassIds
                                : (period?.ClassId && period.ClassId !== 'Free' ? [period.ClassId] : []))
                            : 'Free';
                        formattedRow[`isFree${index + 1}`] = !teaching;
                    });
                    return formattedRow;
                });
                const EditsortedData = timeTableEditData.sort((a, b) => {
                    return days.indexOf(a?.Day) - days.indexOf(b?.Day);
                });

                setEditTableData(EditsortedData);
                Loader.hide();
            } else {
                setPeriodsList([]);
                setEditTableData([]);
                Loader.hide();
                Toast.error({ message: response?.message });
            }
        } catch (error) {
            Loader.hide();
            console.error("Error fetching timetable:", error);
            catchResponse(error);
        }
    };

    const GetSubjectList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getSubjectList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let subjectData = res?.data
                        ?.filter(y => y?.Status == 'Active' && y?.Teachers?.split(',')?.includes(props?.location?.state?.TeacherId))
                        ?.map(x => ({
                            label: x?.SubjectName,
                            value: x?._id,
                            Classes: x?.Classes
                        }));
                    setSubjectList([...subjectData]);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const getClassOptions = (subjectId) => {
        const subject = subjectList.find(s => s?.value === subjectId);
        if (subject?.Classes) {
            const allowed = subject.Classes.split(',').map(s => s.trim());
            return classList.filter(c => allowed.includes(c?.value));
        }
        return classList;
    };

    const handleDropdownChange = (e, rowData, period) => {
        const index = period.replace('Period', '');
        const subject = subjectList.find(s => s?.value === e.value);
        const allowed = subject?.Classes ? subject.Classes.split(',').map(s => s.trim()) : null;
        const updatedData = editTableData.map(row => {
            if (row?.Day === rowData?.Day) {
                const next = { ...row, [period]: e.value };
                if (allowed) {
                    const current = Array.isArray(next[`Class${index}`]) ? next[`Class${index}`] : [];
                    next[`Class${index}`] = current.filter(c => allowed.includes(c));
                }
                return next;
            }
            return row;
        });
        const sortedData = updatedData.sort((a, b) => {
            return days.indexOf(a?.Day) - days.indexOf(b?.Day);
        });
        setEditTableData(sortedData);
    };

    const handleClassDropdownChange = (e, rowData, period) => {
        const updatedData = editTableData.map(row => {
            if (row?.Day === rowData?.Day) {
                return { ...row, [period]: e.value };
            }
            return row;
        });

        const sortedData = updatedData.sort((a, b) => {
            return days.indexOf(a?.Day) - days.indexOf(b?.Day);
        });

        setEditTableData(sortedData);
    };

    const saveTimeTable = async () => {
        try {
            const requestData = editTableData.map(row => ({
                id: row?.Id,
                Day: row?.Day,
                FinancialYearId: selectedYear,
                StartDate: !CommonConfig.isEmpty(startDateValue) ? moment(startDateValue).format("YYYY-MM-DD") : '',
                EndDate: !CommonConfig.isEmpty(endDateValue) ? moment(endDateValue).format("YYYY-MM-DD") : '',
                Periods: periodsList.map((period, index) => {
                    const rawClass = row[`Class${index + 1}`];
                    const classArr = (period?.Time?.includes('Free') || rawClass === 'Free')
                        ? []
                        : (Array.isArray(rawClass) ? rawClass : (rawClass ? [rawClass] : []));
                    return {
                        TeacherId: props?.location?.state?.TeacherId ?? '',
                        Time: period?.Time,
                        SubjectId: period?.Time?.includes('Free') ? '' : row[`Period${index + 1}`],
                        ClassId: classArr,
                    };
                })
            }));

            const response = await api.post(APIConstant.path.AddUpdateTeacherTimeTableEntry, requestData);
            if (response.success) {
                Toast.success({ message: response.message });
                navigate('/time-table-configuration');
            } else {
                Toast.error({ message: "Failed to save timetable" });
            }
        } catch (error) {
            console.error("Error saving timetable:", error);
            catchResponse(error);
        }
    };

    const handleEditColumnName = (type, rowIndex, value) => {
        setPeriodsList((prevItems) =>
            prevItems.map((item, index) =>
                index === rowIndex ? { ...item, [type]: new Date(value) } : item
            )
        );
    };

    const handleDeleteColumn = (index) => {
        const updatedPeriodsList = periodsList.filter((_, i) => i !== index);
        const updatedTableData = editTableData.map((row) => {
            const updatedRow = { ...row };
            delete updatedRow[`Period${index + 1}`];
            return updatedRow;
        });
        setPeriodsList(updatedPeriodsList);
        setEditTableData(updatedTableData);
    };

    const handleToggleEdit = (rowIndex) => {
        setPeriodsList((prevItems) =>
            prevItems.map((item, index) => {
                if (index === rowIndex) {
                    let formattedTime = item?.Time;
                    if (item?.isEdit && item?.FromTime && item?.ToTime) {
                        const formatTime = (time) => {
                            const date = new Date(time);
                            const hours = date.getHours();
                            const minutes = date.getMinutes();
                            const ampm = hours >= 12 ? 'PM' : 'AM';
                            const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
                            const formattedMinutes = minutes.toString().padStart(2, '0');
                            return `${formattedHours}:${formattedMinutes} ${ampm}`;
                        };
                        formattedTime = `${formatTime(item.FromTime)} - ${formatTime(item.ToTime)}`;
                    }

                    return {
                        ...item,
                        isEdit: !item?.isEdit,
                        Time: formattedTime,
                    };
                }
                return {
                    ...item,
                    isEdit: false,
                };
            })
        );
    };

    const handleToggleBreak = (rowIndex, value) => {
        setPeriodsList((prevItems) =>
            prevItems.map((item, index) => {
                if (index === rowIndex) {
                    return {
                        ...item,
                        isBreak: value,
                    };
                }
                return {
                    ...item,
                };
            })
        );
        const updatedTableData = editTableData.map((row, rowIdx) => {
            const updatedRow = { ...row };
            if (value) {
                updatedRow[`isFree${rowIndex + 1}`] = value;
                updatedRow[`Period${rowIndex + 1}`] = 'Free';
                updatedRow[`Class${rowIndex + 1}`] = 'Free';
            } else {
                const originalValue = props?.location?.state?.tableData[rowIdx]?.[`Period${rowIndex + 1}`];
                const originalTeacherValue = props?.location?.state?.tableData[rowIdx]?.[`Class${rowIndex + 1}`];
                const originalFreeValue = value;
                updatedRow[`Period${rowIndex + 1}`] = (originalValue === 'Free' ? '' : originalValue) ?? updatedRow[`Period${rowIndex + 1}`];
                updatedRow[`Class${rowIndex + 1}`] = (originalTeacherValue === 'Free' ? '' : originalTeacherValue) ?? updatedRow[`Class${rowIndex + 1}`];
                updatedRow[`isFree${rowIndex + 1}`] = originalFreeValue ?? updatedRow[`isFree${rowIndex + 1}`];
            }
            return updatedRow;
        });
        setEditTableData(updatedTableData);
    };

    const handleToggleFree = (rowIndex, value, dayValue) => {
        const updatedTableData = editTableData.map((row, rowIdx) => {
            if (row?.Day === dayValue) {
                const updatedRow = { ...row };
                if (value) {
                    updatedRow[`isFree${rowIndex + 1}`] = value;
                    updatedRow[`Period${rowIndex + 1}`] = 'Free';
                    updatedRow[`Class${rowIndex + 1}`] = 'Free';
                } else {
                    const originalValue = props?.location?.state?.tableData[rowIdx]?.[`Period${rowIndex + 1}`];
                    const originalTeacherValue = props?.location?.state?.tableData[rowIdx]?.[`Class${rowIndex + 1}`];
                    const originalFreeValue = value;
                    updatedRow[`Period${rowIndex + 1}`] = (originalValue === 'Free' ? '' : originalValue) ?? updatedRow[`Period${rowIndex + 1}`];
                    updatedRow[`Class${rowIndex + 1}`] = (originalTeacherValue === 'Free' ? '' : originalTeacherValue) ?? updatedRow[`Class${rowIndex + 1}`];
                    updatedRow[`isFree${rowIndex + 1}`] = originalFreeValue ?? updatedRow[`isFree${rowIndex + 1}`];
                }
                return updatedRow;
            }
            return row;
        });

        setEditTableData(updatedTableData);
        const allRowsAreFree = updatedTableData.every(row => row[`isFree${rowIndex + 1}`]);

        setPeriodsList((prevItems) =>
            prevItems.map((item, index) => {
                if (index === rowIndex) {
                    return {
                        ...item,
                        isBreak: allRowsAreFree,
                    };
                }
                return {
                    ...item,
                };
            })
        );
    };

    const handleAddColumn = () => {
        const newColumn = {
            Time: `New Column ${periodsList.length + 1}`,
            isEdit: true,
            isBreak: false
        };
        setPeriodsList([...periodsList, newColumn]);
        const updatedTableData = editTableData.map((row) => ({
            ...row,
            [`Period${periodsList.length + 1}`]: '',
        }));
        setEditTableData(updatedTableData);
    };

    const handleStartDateChange = (e) => {
        const selectedDate = e.value;
        setStartDateValue(selectedDate);

        if (endDateValue && selectedDate && endDateValue < selectedDate) {
            setEndDateValue(null);
        }
    };

    const handleSearch = () => {
        if (startDateValue) {
            GetTimeTableData(props?.location?.state?.TeacherId, startDateValue, endDateValue);
        }
    };

    return (
        <div className="wayment-owner-dashboard et-master-page">
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-center">
                    <i
                        className="pi pi-arrow-left"
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate('/time-table-configuration')}
                        title="Back"
                    ></i>
                    <h2>Edit Teacher Time Table</h2>
                </div>
                <div>
                    <Button
                        className="p-m-0 e-btn"
                        icon="pi pi-plus"
                        onClick={handleAddColumn}
                    />
                </div>
            </div>
            <div className="p-grid">
                <div className="p-col-4 p-md-2">
                    <label htmlFor="startDateTime">Start Date</label>
                    <div>
                        <Calendar
                            className="p-w-100 p-mt-0"
                            id="startDateTime"
                            onChange={handleStartDateChange}
                            placeholder="DD/MM/YYYY"
                            value={startDateValue}
                            hideOnDateTimeSelect
                            dateFormat="dd/mm/yy"
                            minDate={academicStartDate}
                            maxDate={academicEndDate}
                        />
                    </div>
                </div>
                <div className="p-col-4 p-md-2">
                    <label htmlFor="endDateTime">End Date</label>
                    <div>
                        <Calendar
                            className="p-w-100 p-mt-0"
                            id="endDateTime"
                            onChange={(e) => setEndDateValue(e.value)}
                            placeholder="DD/MM/YYYY"
                            hideOnDateTimeSelect
                            value={endDateValue}
                            dateFormat="dd/mm/yy"
                            minDate={CommonConfig.parseDDMMYYYYToDate(startDateValue) ?? academicStartDate}
                            maxDate={academicEndDate}
                        />
                    </div>
                </div>
                <div className="p-col-12 p-md-2 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="selectedYear">Academic Years</label>
                        <Dropdown
                            id="selectedYear"
                            value={selectedYear}
                            options={props?.location?.state?.academicYearList ?? []}
                            onChange={(e) => setSelectedYear(e.value)}
                            placeholder="Select Academic Year"
                            display="chip"
                            className='p-w-100 p-mt-1'
                            filter
                            optionLabel="label"
                            optionValue="_id"
                            showClear
                        />
                    </div>
                </div>
                <div className="p-col-4 p-md-2">
                    <Button
                        label="Search"
                        icon="pi pi-search"
                        className="p-button-primary p-mt-4"
                        onClick={handleSearch}
                    />
                </div>
            </div>
            {classList.length > 0 && (
                <DataTable
                    value={editTableData}
                    responsiveLayout="scroll"
                    className='custom-table'
                    scrollHeight='calc(100vh - 120px)'
                    size='small'
                >
                    <Column field="Day" header="Days/Periods" />
                    {periodsList?.map((period, index) => (
                        <Column
                            key={index}
                            field={`Period${index + 1}`}
                            header={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {period?.isEdit ? (
                                        <>
                                            <Calendar
                                                value={period?.FromTime}
                                                onChange={(e) => handleEditColumnName('FromTime', index, e.value)}
                                                hourFormat="12"
                                                showTime
                                                showSeconds={false}
                                                timeOnly
                                                className='time-table-input'
                                            />
                                            <Calendar
                                                value={period?.ToTime}
                                                onChange={(e) => handleEditColumnName('ToTime', index, e.target.value)}
                                                hourFormat="12"
                                                showTime
                                                showSeconds={false}
                                                timeOnly
                                                className='p-ml-2 time-table-input'
                                            />
                                        </>
                                    ) : (
                                        <div>{period?.Time}</div>
                                    )}
                                    <Button
                                        icon={period?.isEdit ? "pi pi-check" : "pi pi-pencil"}
                                        className={period?.isEdit ? "p-button-text" : "p-button-text p-button-danger"}
                                        onClick={() => handleToggleEdit(index)}
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-text p-button-danger"
                                        onClick={() => handleDeleteColumn(index)}
                                    />
                                    <Checkbox
                                        inputId="randomCheckbox"
                                        checked={period?.isBreak}
                                        onChange={(e) => handleToggleBreak(index, e.checked)}
                                    />
                                    <label htmlFor="randomCheckbox" style={{ marginLeft: '8px' }}>Free All</label>
                                </div>
                            }
                            body={(rowData) => {
                                return (
                                    <>
                                        <Checkbox
                                            inputId="randomCheckbox"
                                            checked={rowData[`isFree${index + 1}`]}
                                            onChange={(e) => handleToggleFree(index, e.checked, rowData?.Day)}
                                        />
                                        <label htmlFor="randomCheckbox" style={{ marginLeft: '8px' }}>
                                            Free
                                        </label>

                                        {!rowData[`isFree${index + 1}`] && (
                                            <div className="dropdown-container">
                                                <Dropdown
                                                    value={rowData[`Period${index + 1}`]}
                                                    options={subjectList}
                                                    onChange={(e) => handleDropdownChange(e, rowData, `Period${index + 1}`)}
                                                    placeholder="Select Subject"
                                                    style={{ width: '100%' }}
                                                    filter
                                                    showClear
                                                />
                                                <MultiSelect
                                                    value={Array.isArray(rowData[`Class${index + 1}`]) ? rowData[`Class${index + 1}`] : []}
                                                    options={getClassOptions(rowData[`Period${index + 1}`])}
                                                    onChange={(e) => handleClassDropdownChange(e, rowData, `Class${index + 1}`)}
                                                    placeholder="Select Class(es)"
                                                    className="dropdown"
                                                    display="chip"
                                                    filter
                                                    showClear
                                                    disabled={CommonConfig.isEmpty(rowData[`Period${index + 1}`])}
                                                />
                                                {Array.isArray(rowData[`Class${index + 1}`]) && rowData[`Class${index + 1}`].length > 1 && (
                                                    <small style={{ color: '#1c515e', display: 'block', marginTop: 4 }}>
                                                        Combined class — taught together this period.
                                                    </small>
                                                )}
                                                {(() => {
                                                    const selected = Array.isArray(rowData[`Class${index + 1}`]) ? rowData[`Class${index + 1}`] : [];
                                                    const nonSubject = selected.filter(cid => classConfigMap[String(cid)] && classConfigMap[String(cid)] !== 'SubjectTeacher');
                                                    if (!nonSubject.length) return null;
                                                    const names = nonSubject.map(cid => (classList.find(c => c?.value === cid)?.label) || cid).join(', ');
                                                    return (
                                                        <small style={{ color: '#c0392b', display: 'block', marginTop: 4 }}>
                                                            Note: {names} {nonSubject.length > 1 ? 'do' : 'does'} not use Subject-wise attendance (e.g. Class Teacher mode) — subject-wise attendance won't apply; {nonSubject.length > 1 ? 'their' : 'its'} attendance is taken by the class teacher.
                                                        </small>
                                                    );
                                                })()}
                                            </div>
                                        )}
                                    </>
                                );
                            }}

                        />
                    ))}
                </DataTable>)}
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
                <Button
                    className="p-m-0 btn-text-action-primary p-m-1 color-white"
                    label="Update"
                    severity="secondary"
                    raised
                    onClick={(e) => saveTimeTable()}
                />
            </div>
        </div>
    );
};

export default EditTeacherTimeTable;
